<data-table
  (detail)="onDetail($event)"
  [columns]="columns"
  [dataProviderParams]="params"
  [dataProvider]="screenService"
  [title]="'Screens'"
>
</data-table>
